/**
 * 옆으로 구르는 통의 **양 끝 판정** — 화살표 줄(`ScrollRow`)과 표·칩 줄의 오른쪽 띠(`useHubScrollEdge`)가 함께 쓴다.
 * 🔑 1px 은 소수 픽셀 반올림 여유다 — 끝까지 밀어도 0.5px 이 남아 「더 있다」로 읽히지 않게.
 */

/** 통의 폭·위치 세 값 — DOM 요소에서 그대로 읽는다 */
export type ScrollBox = { scrollLeft: number; scrollWidth: number; clientWidth: number };

/**
 * 왼쪽·오른쪽에 아직 가려진 내용이 있나.
 * @returns `start` 왼쪽이 남았다(처음이 아니다) · `end` 오른쪽이 남았다(끝이 아니다) — 다 들어가면 둘 다 거짓
 */
export function readScrollEdges({ scrollLeft, scrollWidth, clientWidth }: ScrollBox) {
  return {
    start: scrollLeft > 1,
    end: scrollWidth - clientWidth - scrollLeft > 1,
  };
}

/**
 * 화살표 한 번에 미는 거리 — 보이는 폭의 80%(앞 화면의 끝 카드가 다음 화면 첫머리에 남아 이어 읽힌다).
 * @returns 0 이상의 px
 */
export function scrollRowStep(clientWidth: number) {
  return Math.max(0, Math.round(clientWidth * 0.8));
}
